// extracted by mini-css-extract-plugin
export default {"menu-container":"SetVariablesModal_menu-container__vv4Hy"};